import { Component, OnInit, Inject } from '@angular/core';
import { Input } from '@syncfusion/ej2-inputs';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { EditUserPermissionForDoc, RemoveUserForDoc, ShareDocumentToMembers } from '../../home/resources/_store/resources.actions';
import { NotificationModalComponent } from '../notification-modal/notification-modal.component';
import { UsersListComponent } from '../../home';
import { userInfo } from 'os';
import { API } from 'src/app/services/Api.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { NotificationsService } from "angular2-notifications";


@Component({
  selector: 'app-doc-access-permission',
  templateUrl: './doc-access-permission.component.html',
  styleUrls: ['./doc-access-permission.component.scss']
})
export class DocAccessPermissionComponent implements OnInit {

  details;
  permissionArray = [
    {
      viewLabel: 'Can Edit',
      value: 'collaborator'
    },
    {
      viewLabel: 'Can View',
      value: 'viewer' 
    },
    {
      viewLabel: 'No Access',
      value: 'no_access'
    },
    {
      viewLabel: 'Owner',
      value: 'owner'
    }
  ];
  type: any;
  addPermissions = [];
  editPermissions = [];
  removePermissions = [];
  hasSharePermissions = true;
  constructor(
    private matDialogRef: MatDialogRef<DocAccessPermissionComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private store: Store<AppState>,
    private matDialog: MatDialog,
    private api: API,
    private ngxPermissionService: NgxPermissionsService,
    private notificationService: NotificationsService,
  ) {
    this.matDialogRef.disableClose = true;
    this.details = data.detail.map(item => {
      return {
        ...item,
        users : item.users.filter(user => user._id !== item.attachedBy._id ).map(user => {
          return {
          ...user,
          role : user.docRole
          };
        })
      };
    });
    console.log("details", this.details);
    this.type = data.type;
  }

  ngOnInit() {
      this.hasSharePermissions = Object.keys(this.ngxPermissionService.getPermissions()).includes('share-document');
      console.log(this.hasSharePermissions);
  }

  ClickOk() {
    const payload = {
      add: this.addPermissions,
      edit: this.editPermissions,
      remove: this.removePermissions
      };
    this.api.addUserCapablitiesForDocNew(payload).subscribe(response => {
      this.matDialogRef.close(true);
    }, err => {
      this.notificationService.error(err.error.errors[0].error);
      this.matDialogRef.close(false);
    });
  }

  onEditUserPermission(event, documentId, user) {
    const dialogRef = this.matDialog.open(NotificationModalComponent, {
      width: '40%',
      panelClass: 'cmp-modal',
      data: {
        text: 'Are you sure you want to change the existing permission?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      let seletedMem = [];
      seletedMem = [...seletedMem, ...user];
      if (result) {
        if (user.docRole === 'no_access') {
            this.store.dispatch(
              new ShareDocumentToMembers(
                documentId,
                event.value,
                seletedMem
              )
            );
        } else if (event.value === 'no_access') {
          this.store.dispatch(new RemoveUserForDoc(
              documentId,
              user.type,
              user._id,
              user.docRole
            )
          );
        } else {
          this.store.dispatch(
            new EditUserPermissionForDoc(
              documentId,
              user.type,
              user._id,
              event.value,
              true
            ));
        }
        user.docRole = event.value;
      }
    });
  }

  editUserPermission(event, documentId , user) {
    const payload = {
      docId : documentId,
      userId: user._id,
      type: user.type,
      // role: event.value
    };
    this.removeExistingPermissionsForUser(documentId, user);
    const currentDocument = this.details.filter(item => item.document._id === documentId)[0];
    const currentUserInDoc = currentDocument.users.filter(usr => usr._id === user._id)[0];
    if (event.value === 'no_access') {
      payload['role'] = currentUserInDoc.role;
    } else {
      payload['role'] = event.value;
    }
    if (event.value === 'no_access' && currentUserInDoc.role !== 'no_access') {
      this.removePermissions.push(payload);
    } else if (currentUserInDoc.role === 'no_access' && event.value !== 'no_access') {
          this.addPermissions.push(payload);
    } else if (currentUserInDoc.role !== event.value) {
        this.editPermissions.push(payload);
    }
    user.docRole = event.value;
  }

  removeExistingPermissionsForUser(documentId, user) {
    const addPermissionsIndex = this.addPermissions.findIndex(obj => obj.docId === documentId && obj.userId === user._id);
    if (addPermissionsIndex !== -1) {
      this.addPermissions.splice(addPermissionsIndex, 1);
    }

    const editPermissionIndex = this.editPermissions.findIndex(obj => obj.docId === documentId && obj.userId === user._id);
    if (editPermissionIndex !== -1) {
      this.editPermissions.splice(editPermissionIndex, 1);
    }

    const removePermissionsIndex = this.removePermissions.findIndex(obj => obj.docId === documentId && obj.userId === user._id);
    if (removePermissionsIndex !== -1) {
      this.removePermissions.splice(removePermissionsIndex, 1);
    }

  }

  // getPermissionArray(docRole) {
  //   if (docRole === 'collaborator') {
  //     return [
  //       {
  //         viewLabel: 'Can View',
  //         value: 'viewer'
  //       }
  //     ];
  //   } else {
  //     return this.permissionArray;
  //   }
  // }

  cancel() {
    this.matDialogRef.close(false);
  }

}
